import React, { useContext } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import { FormattedMessage } from 'react-intl'
import DashboardHeaderSubmenu from './DashboardHeaderSubmenu'
import { useMediaQuery } from 'react-responsive'
import classNames from 'classnames'
import { ResponsiveContext } from '../../../utils/context/responsiveContext'

const useStyle = makeStyles((theme) => {
	return {
		...styles(theme),
		dashboardStyle: {
			position: 'relative',
			backgroundSize: 'cover',
			backgroundPosition: 'center',

			'& img': {
				width: '100%'
			},

			'& #header_text': {
				position: 'absolute',
				color: 'white',
				left: '5%',
				transform: 'translate(0 ,-50%)'
			}
		},
		dashboardLargeScreenStyle: {
			marginBottom: 70,

			'& #header_text': {
				width: '70%',
				top: '50%'
			}
		},
		dashboardSmallScreenStyle: {
			marginBottom: 187,

			'& #header_text': {
				width: '95%',
				bottom: '35%'
			}
		},
		dashboardMediumScreenStyle: {
			marginBottom: 187,

			'& #header_text': {
				width: '95%',
				top: '50%'
			}
		},
		dashboardImageLargeScreenStyle: {
			backgroundImage: `url('img/dashboard/${process.env.REACT_APP_TARGET}/bandeau.jpg')`,
			height: '350px'
		},
		dashboardImageSmallScreenStyle: {
			backgroundImage: `url('img/dashboard/${process.env.REACT_APP_TARGET}/bandeau_small.jpg')`,
			height: '415px'
		},
		handleBreakLine: {
			whiteSpace: 'pre-line'
		}
	}
})

const DashboardHeader = () => {
	const classes = useStyle()
	const { isLargeScreen } = useContext(ResponsiveContext)
	const isMobileScreen = useMediaQuery(
		{
			query: '(min-width: 463px)'
		}
	)

	const dashboardClass = classNames(
		{
			[classes.dashboardLargeScreenStyle]: isMobileScreen && isLargeScreen,
			[classes.dashboardSmallScreenStyle]: !isMobileScreen && !isLargeScreen,
			[classes.dashboardMediumScreenStyle]: isMobileScreen && !isLargeScreen,
			[classes.dashboardImageLargeScreenStyle]: isLargeScreen,
			[classes.dashboardImageSmallScreenStyle]: !isLargeScreen
		},
		classes.dashboardStyle
	)
	const titleClass = classNames(
		classes.handleBreakLine,
		{
			[classes.title1]: isLargeScreen,
			[classes.title2]: !isLargeScreen
		}
	)

	return (
		<div className={dashboardClass}>
			<span
				className={titleClass}
				id="header_text"
			>
				<FormattedMessage
					id="dashboard.welcome"
					defaultMessage="Bienvenue sur
					votre Espace Client"
					description="Dashboard header welcome text"
				/>
			</span>

			<DashboardHeaderSubmenu />
		</div>
	)
}

export default DashboardHeader
